// @format
export enum ClientType {
  API = 0,
  Storage = 1,
}
